module.exports = __webpack_public_path__ + "img/playngo.a656aa6b.svg";